import React from 'react'

export default function TableCellGameTeam(props) {
  return (
    <div className={'d-center align-items-center fs-16 sm-fs-14 color-3a3335 ph-10 sm-ph-5 ' + props.className} onClick={props.onClick}>
      {props.home}
      {props.handi != 0 &&
        <div className='fs-14 sm-fs-12 mt-2 color-e45a5a'> (H{props.handi})</div>
      }
      {props.uo != 0 &&
        <div className='fs-14 sm-fs-12 mt-2 color-3a6d99'> (U/O{props.uo})</div>
      }
      {'  :  ' + props.away}
    </div>
  )
}